import { useTranslation } from 'react-i18next';
import { EmptyTable } from '@coverflex-tech/hypernova';

interface IEmptyTransactionsPlaceholderProps {
  translationPrefix?: 'home';
}

export const EmptyTransactionsPlaceholder = ({
  translationPrefix,
}: IEmptyTransactionsPlaceholderProps) => {
  const { t } = useTranslation();
  return (
    <EmptyTable
      title={t(
        `wallet.activity.${
          translationPrefix ? `${translationPrefix}.` : ''
        }empty_placeholder.title`
      )}
      description={t(
        `wallet.activity.${
          translationPrefix ? `${translationPrefix}.` : ''
        }empty_placeholder.description`
      )}
    />
  );
};
